import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { NavigationStart, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import type { IInputNameToValueMap } from '@shared/common/data/inputs';
import { PRODUCT_ALIAS_TO_ID_MAP } from '@shared/jp/product';
import type { ICommonBookData } from '@shared/jp/models';
import { ROUTE_QUERY_PARAM_GIFT } from '@studiobuki/web-core/lib/routing';
import { FirebaseService } from 'src/app/services/firebase.service';
import type { BookFormComponent } from '@studiobuki/web-core/lib/book-form';
import { Logger } from '@shared/common/logger';
import type { TBookAlias, TBookCover } from '@shared/jp/product';
import { BooksService } from 'src/app/shared/book-page-common/services/books.service';
import { GAGetEvents, GATrack } from 'src/analytics';

const log = new Logger('BookFormDialogComponent');

@Component({
  selector: 'app-book-form-dialog',
  templateUrl: './book-form-dialog.component.html',
  styleUrls: ['./book-form-dialog.component.scss'],
})
export class BookFormDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      alias: BookFormComponent<TBookAlias>['alias'];
      cover: TBookCover;
      inputs: BookFormComponent<TBookAlias>['inputs'];
      code: string;
    },
    public dialogRef: MatDialogRef<BookFormDialogComponent>,
    private _router: Router,
    private _firebaseService: FirebaseService,
    private _booksService: BooksService,
  ) {
    this._router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        take(1),
      )
      .subscribe(() => {
        this.dialogRef.close();
      });
  }

  async onSubmit(value: IInputNameToValueMap) {
    const { alias, cover, code: gift } = this.data;

    const common: Partial<ICommonBookData> = {
      cover,
      gift,
    };

    const newBookId = await this._booksService.createBookByAlias(
      alias,
      value,
      common,
    );

    log.info('created book', newBookId);

    await this._router.navigate(['book', newBookId], {
      // replaceUrl: true,
      queryParams: {
        [ROUTE_QUERY_PARAM_GIFT]: gift,
      },
    });

    log.info('submit', alias, value);

    const bookAliasId = PRODUCT_ALIAS_TO_ID_MAP[alias];

    GATrack(GAGetEvents.getBookPreview(bookAliasId));
  }
}
